import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadModalities () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('modalities', { params })
      .then(result => {
        this.modalities = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (modalityId) {
    this.showDeleteDialog = true
    this.deletingId = modalityId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Modalidade excluída')
          this.loadModalities()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir modalidade')
        this.loadModalities()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
